import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpParams} from '@angular/common/http';
import {PayrollAmount} from '../entities/payroll-amount';
import {BaseCrudService} from '../../shared/_utils/services/base-crud-service';
import {LazyLoadEvent} from 'primeng/primeng';
import {QueryOperator} from '../../shared/_utils/services/query-operator.enum';
import {tap, catchError} from 'rxjs/operators';
import {MassivePayrollAmount} from '../model/massive-payroll-amount';
import {ResponsePageable} from '../../shared/_utils/services/responsePageable';
import { map } from 'rxjs/operator/map';
import { Subject } from 'rxjs';

@Injectable()
export class PayrollAmountService extends BaseCrudService<PayrollAmount> {

  public updateTotalesRefresh:Subject<any> = new Subject<any>();
  protected httpParams = new HttpParams();
  public uri = '/api/payrollAmount/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PayrollAmountService');
  }

  buildSentence(entity?: PayrollAmount, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';

      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }

      if (entity.month && entity.month.id) {
        query = query.concat(
          `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
        );
      }

      if (entity.employeeType && entity.employeeType.id) {
        query = query.concat(
          `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
        );
      }

      if (entity.mpayrollConcept && entity.mpayrollConcept.id) {
        query = query.concat(
          `mpayrollConcept.id${QueryOperator.Equal}${entity.mpayrollConcept.id}${QueryOperator.Split}`
        );
      }

      if (entity.mpayrollConcept ) {
          if (entity.mpayrollConcept.payrollConcept && entity.mpayrollConcept.payrollConcept.sign) {
              query = query.concat(
                  // tslint:disable-next-line:max-line-length
                  `mpayrollConcept.payrollConcept.sign${QueryOperator.Equal}${entity.mpayrollConcept.payrollConcept.sign}${QueryOperator.Split}`
              );
          }
      }

      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }

      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.payrollType && entity.payrollType.id) {
        query = query.concat(
          `payrollType.id${QueryOperator.Equal}${entity.payrollType.id}${QueryOperator.Split}`
        );
      }
      // debugger;
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchMassivePayrollAmount(entity?: PayrollAmount, event?: LazyLoadEvent): Observable<ResponsePageable<PayrollAmount>> {
    const url = this.rutaServidor + this.uri + 'search';
   //console.log('searchMassivePayrollAmount');
    this.spinnerService.showAll();
   //console.log(this.buildSentence(entity, event));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<ResponsePageable<PayrollAmount>>(url, { params: this.buildSentence(entity, event) })
        .pipe(
            tap(response => {
                if (response.numberOfElements > 0) {
                    response.content.forEach((value) => {
                        // debugger;
                        this.convertToDate(value);
                    })
                }
               //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
  }

  bulkLoadValidate(massivePayrollAmountList: MassivePayrollAmount[]): Observable<MassivePayrollAmount[]> {
   //console.log('bulkLoadValidate');
   //console.log(massivePayrollAmountList);
    this.httpParams = this.httpParams.set(QueryOperator.Action, 'validate');
    const url = `${this.rutaServidor}${this.uri}bulkLoad`;
    return this.httpClient.post<MassivePayrollAmount[]>(url, massivePayrollAmountList, {params: this.httpParams})
    .pipe(
      tap(response => {
        this.convertToDate(response);
        this.spinnerService.hideAll();
       //console.log(response);
      })
    );
  }

  bulkLoadCreate(massivePayrollAmountList: MassivePayrollAmount[]): Observable<MassivePayrollAmount[]> {
   //console.log('bulkLoadCreate');
   //console.log(massivePayrollAmountList);
    this.httpParams = this.httpParams.set(QueryOperator.Action, 'create');
   //console.log(this.httpParams);
     this.spinnerService.showAll();
    const url = `${this.rutaServidor}${this.uri}bulkLoad`;
    return this.httpClient.post<MassivePayrollAmount[]>(url, massivePayrollAmountList, {params: this.httpParams})
      .pipe(
        tap(response => {
          this.convertToDate(response);
          this.spinnerService.hideAll();
         //console.log(response);
        })
        ,
        catchError(e=>{  
            this.spinnerService.hideAll();
            let newEntity : MassivePayrollAmount
            this.notificationService.smallBoxError(e.error.messages[0]); 
              return Observable.throw(newEntity);
          })
      );
  }


    searchAmount(entity?: PayrollAmount, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<ResponsePageable<PayrollAmount>> {

        const url = this.rutaServidor + this.uri  + 'searchAmount';
      //  console.log('dentro del searchAmount');
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<PayrollAmount>>(url, { params: this.buildSentence(entity, event) })
            .pipe(
                tap(response => {
                    if (response.totalElements > 0) {
                        response.content.forEach((value) => {
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    }
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

    deleteId(id: number): Observable<any> {
      const url = this.rutaServidor + this.uri + id;
     //console.log(url);
      return this.httpClient.delete(url);
  }

  deleteMassivePayrollAmount(entity: any): Observable<any> {
    const url = this.rutaServidor + this.uri + 'deleteMassivePayrollAmount';    
    return this.httpClient.post(url, entity);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/payroll-amount.service.ts